import React from 'react';
import { Terminal, RefreshCw, Play, Loader2 } from 'lucide-react';

interface Props {
  error?: string | null;
  isStarting?: boolean;
  onRetry: () => void;
  onStartServer?: () => void;
}

export const IframeEmptyState: React.FC<Props> = ({ error, isStarting, onRetry, onStartServer }) => {
  const command = 'cd slot-core && npm run dev';

  const handleCopy = () => {
    navigator.clipboard.writeText(command);
  };

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-zinc-950">
      <div className="text-center max-w-sm space-y-4">
        <div className="flex justify-center">
          <Terminal className="w-12 h-12 text-zinc-600" />
        </div>
        <h3 className="text-zinc-300 font-medium">Game Server Not Running</h3>
        <p className="text-zinc-500 text-sm">
          Start the slot-core dev server to see the live preview:
        </p>

        {/* Auto-start button */}
        {onStartServer && (
          <button
            onClick={onStartServer}
            disabled={isStarting}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-500 disabled:bg-blue-800 disabled:opacity-60 text-white rounded-lg text-sm font-medium transition-colors"
          >
            {isStarting ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Starting Server...
              </>
            ) : (
              <>
                <Play className="w-4 h-4" />
                Start Game Server
              </>
            )}
          </button>
        )}

        <div className="text-zinc-600 text-xs">or run manually:</div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-3 text-left">
          <code className="text-amber-400 text-sm font-mono">{command}</code>
          <button
            onClick={handleCopy}
            className="ml-2 text-zinc-500 hover:text-zinc-300 text-xs"
            title="Copy command"
          >
            Copy
          </button>
        </div>
        {error && (
          <p className="text-red-400 text-xs">{error}</p>
        )}
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-lg text-sm transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          Retry Connection
        </button>
      </div>
    </div>
  );
};
